<!-- Container for the confirmation dialog -->
<div class="pb-4 pl-4 pr-4 pt-2 confirmation">
  <div class="confirm-icon" aria-hidden="true">
    <i class="bx bx-error"></i>
  </div>

  <!-- Dialog content section -->
  <mat-dialog-content class="confirmation-content pb-3">
    <!-- Header for the confirmation dialog -->
    <div class="confirm-header">{{ title }}</div>

    <!-- Message body for the confirmation dialog, dynamically populated -->
    <p class="confirm-body pt-3" [innerHTML]="message">
      <!-- {{message}} -->
    </p>
  </mat-dialog-content>

  <!-- Dialog actions section -->
  <mat-dialog-actions align="center">
    <!-- Cancel button, closes the dialog -->
    <button
      *ngIf="cancelButtonText"
      mat-raised-button
      mat-dialog-close
      tabindex="-1"
      class="btn cancel-btn mr-3 bg-white text-black-50"
    >
      {{ cancelButtonText }}
    </button>

    <!-- Confirm button, triggers confirmation logic -->
    <button
      mat-raised-button
      class="btn confirm-btn text-white"
      (click)="onConfirmClick()"
      tabindex="0"
    >
      {{ confirmButtonText }}
    </button>
  </mat-dialog-actions>
</div>
